import React, { useState, useEffect, useRef ,useLayoutEffect} from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { newProductCreation,resetProductCreatiion,imageuploadProcess,imageUploadFailureProcess ,productModification,getSingleProduct,getSingleProductImage,productImageModification,getAllProductImage,productImageDeletion} from "./productAction";
import { newPaxhealthCreation,resetPaxhealthCreatiion,getSinglePaxhealth, paxhealthModification } from "../paxhealth/paxhealthAction";
import { getSingleAgePolicy, agepolicyModification } from "../agepolicy/agepolicyAction";
import { getSingleOccupancyRule, occupancyruleModification } from "../occupancyrule/occupancyruleAction";
import { getSingleCancelPolicy, cancelpolicyModification } from "../cancelpolicy/cancelpolicyAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { getAllServiceType } from "../serviceType/serviceTypeAction";
import { getAllReservationEmail } from "../reservationemails/ReservationEmailAction";
import { getAllCity } from "../city/cityAction";
import { getAllTourType } from "../tourTypes/TourTypeAction";
import { getAllSupplier } from "../suppliers/supplierAction";
import { getAllCountry } from "../country/countryListAction";
import Datetime from "react-datetime";
import { DefaultEditor } from 'react-simple-wysiwyg';
import { upload } from '@testing-library/user-event/dist/upload';
import UploadService from "../../../api/FileUploadApi";
import { useParams,useNavigate, Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import moment from 'moment';
import { FaEdit, FaTrash, FaPlus ,FaCircleXmark, FaArrowLeft} from 'react-icons/fa';
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css'
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ModifyProduct = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const idd = id;
  const idd2 = id;
  const dispatch = useDispatch();
  const [proddisable , setProddisable] = useState(true);
  const [paxdisable , setPaxdisable] = useState(true);
  const [agedisable , setAgedisable] = useState(true);
  const [canceldisable , setCanceldisable] = useState(true);
  const [occdisable , setOccdisable] = useState(true);
  const [productsImage2, setProductsImage2] = useState({
    id: "",
    image: "",


  })
  const [paxhealth,setpaxhealth] = useState({
    id:"",
    idd:id,
    amiweight2:"",
    amaweight:"",
    amiheight:"",
    amaheight:"",
    cmiweight:"",
    cmaweight:"",
    cmiheight:"",
    cmaheight:"",
    acp:"",
    aap:"",
    aip:"",
    healthrestrictions:"",
    status2:"",
    // productId
    
  })

  const [policyage, setpolicyage] = useState({
    id: "",
    idd:id,
    adultage: "",
    schildage: "",
    echildage: "",
    sinfantage: "",
    einfantage: "",

  });

  const [ruleoccupancy, setruleoccupancy] = useState({
    id:"",
    idd:id,
    minadult:"",
    maxadult:"",
    minchild:"",
    maxchild:"",
    mininfant:"",
    maxinfant:"",
 
 
});

  const [policycancel, setpolicycancel] = useState({
    iddp:"",
    idd2:id,
    sdate:"",
    edate:"",
    cbdays:"",
    cbhours:"",
    percentage:"",
    bdays:"",
    minamt:"",
    cremark:"",

 
});
  const [isdummy,setIsdummy]= useState([]);
  const [istricombo,setIstricombo]= useState([]);
  const [isbulkticket,setIsbulkticket]= useState([]);
  const [hasvat,setHasvat]= useState([]);
  const [vouchertosbt,setVouchertosbt]= useState([]);
  const [hastax,sethastax]= useState([]);
  const [isAlive,setIsAlive] = useState(true);
  const [aap,setIsaap]= useState([]);
  const [acp,setIsacp]= useState([]);
  const [aip,setIsaip]= useState([]);

  const [adultage,setAdultAge]= useState('');
  const [schildage,setSChildAge]= useState('');
  const [echildage,setEChildAge]= useState('');
  const [disupload , setDisupload] = useState(true);

  const [sinfantage,setSInfantAge]= useState('');
  const [einfantage,setEInfantAge]= useState('');
  const [products, setProducts] = useState({
    id:"",
    productname:"",
    servicetypeid:"",
    tourtypeid:"",
    phonenumber:"",
    cityid:"",
    countryid:"",
    reservationmailid:"",
    locationid:"",
    // dailystarttime:"",
    // dailyendtime:"",
    nooftrips:"",
    // dresscode:"",
    remarks:"",
    itenarygroupid:"",
    isdummy:"",
    istricombo:"",
    isbulkticket:"",
    hasvat:"",
    vouchertosbt:"",
    hastax:"",
    productdescription:"",
    status:""
  });
  const productData = useSelector((state) => state.productList);
  const paxData = useSelector((state) => state.paxList);
  const ageData = useSelector((state) => state.agepolicyList);
  const occupancyData = useSelector((state) => state.occupancyruleList);
  const cancelData = useSelector((state) => state.cancelpolicyList);
  // console.log("ageData",ageData)
  const { suppliers } = useSelector((state) => state.supplierList);
  const { prmdata,paxMessage,paxstatus,pmstatus } = useSelector((state) => state.paxList);
  const { productagepolicymmessage } = useSelector((state) => state.agepolicyList);
  const { productcancelpolicymmesscancel } = useSelector((state) => state.cancelpolicyList);
  const { productoccupancyrulemmessage } = useSelector((state) => state.occupancyruleList);

  const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      dispatch(getAllProductImage());
      loadProduct(id);
      loadProductImage(id);
      loadcheckbox();
      return () => setIsAlive(false)
    
    }

   // console.log("componentDidUpdateFunction");
  },[isAlive]);
  useEffect(() => { 
    loadcheckbox();
   
    loadProduct(id);
    setProducts({
      id:id,
      productname:"",
      servicetypeid:"",
      tourtypeid:"",
      phonenumber:"",
      cityid:"",
      countryid:"",
      reservationmailid:"",
      locationid:"",
      // dailystarttime:"",
      // dailyendtime:"",
      nooftrips:"",
      // dresscode:"",
      remarks:"",
      itenarygroupid:"",
      isdummy:"",
      istricombo:"",
      isbulkticket:"",
      hasvat:"",
      vouchertosbt:"",
      hastax:"",
      productdescription:"",
      status:""
  });


    loadProductImage(id);









  
    return () => setIsAlive(false)
    
   
     }, [isAlive]);

  function loadProductImage(id){
    dispatch(getSingleProductImage(id));

    setProductsImage2({
        id:id,
        product_image:pIData.product_image
    })
  }

  const pxData = JSON.parse(JSON.stringify(paxData.pSDetails));
  useEffect(() => {
    if (paxData && paxData.pSDetails && paxData.pSDetails.product_id === Number(id)) {
      const pxData = JSON.parse(JSON.stringify(paxData.pSDetails));
      const initialRates = Object.keys(pxData).map((key) => (pxData[key] || '').toString());
      console.log('initialRates:', initialRates);
      setpaxhealth((prevState) => ({
        ...prevState,
        id: pxData.id,
        amiweight2: pxData.adult_min_weight,
        amaweight: pxData.adult_max_weight,
        amiheight: pxData.adult_min_height,
        amaheight: pxData.adult_max_height,
        cmiweight: pxData.child_min_weight,
        cmaweight: pxData.child_max_weight,
        cmiheight: pxData.child_min_height,
        cmaheight: pxData.child_max_height,
        acp: pxData.child_permission,
        aip: pxData.infant_permission,
        aap: pxData.adult_permission,
        healthrestrictions: pxData?.health_restrictions,
        status2: pxData?.status,
      }));
    }
  }, [paxData, id]);



  useEffect(() => {
    if (productData && productData.pSDetails && productData.pSDetails.id === Number(id)) {
      const pData = JSON.parse(JSON.stringify(productData.pSDetails));
      const initialRates = Object.keys(pData).map((key) => (pData[key] || '').toString());
      console.log('initialRates:', initialRates);
      setProducts((prevState) => ({
        ...prevState,
        id:pData.id,
        productname:pData.product_name,
        servicetypeid:pData.service_type_id,
        tourtypeid:pData.tour_type_id,
        phonenumber:pData.phone_number,
        cityid:pData.city_id,
        countryid:pData.country_id,
        reservationmailid:pData.reservation_email_id,
        locationid:pData.location_id,
        nooftrips:pData.no_of_trips,
        remarks:pData.remarks,
        itenarygroupid:pData.itenary_group_id,
        isdummy:pData.is_dummy,
        istricombo:pData.is_tricombo,
        isbulkticket:pData.is_bulkticket,
        hasvat:pData.has_vat,
        vouchertosbt:pData.voucher_to_sbt,
        hastax:pData.has_tax,
        productdescription:pData.product_description,
        status:pData.status
      }));
    }
  }, [productData, id]);


  const apData = JSON.parse(JSON.stringify(ageData.agepolicies));


  useEffect(() => {
    if (ageData && ageData.agepolicies && ageData.agepolicies.product_id === Number(id)) {
      const apData = JSON.parse(JSON.stringify(ageData.agepolicies));
      const initialRates = Object.keys(apData).map((key) => (apData[key] || '').toString());
      setpolicyage((prevState) => ({
        ...prevState,
        id:apData.id,
        adultage:apData.adult_age,
        schildage:apData.schild_age,
        echildage:apData.echild_age,
        sinfantage:apData.sinfant_age,
        einfantage:apData.einfant_age,
      }));
    }
  }, [ageData, id]);


  const cpData = JSON.parse(JSON.stringify(cancelData.cancelpolicies));

  useEffect(() => {
    if (cancelData && cancelData.cancelpolicies && cancelData.cancelpolicies.product_id === Number(id)) {
      const cpData = JSON.parse(JSON.stringify(cancelData.cancelpolicies));
      const initialRates = Object.keys(cpData).map((key) => (cpData[key] || '').toString());
      setpolicycancel((prevState) => ({
        ...prevState,
        iddp:cpData.id,
        sdate:cpData.start_date,
        edate:cpData.end_date,
        cbdays:cpData.cancel_within_days,
        cbhours:cpData.cancel_within_hours,
        percentage:cpData.percentage_amount,
        bdays:cpData.buffer_days,
        minamt:cpData.min_amount,
        cremark:cpData.remark,
      }));
    }
  }, [cancelData, id]);


  const orData = JSON.parse(JSON.stringify(occupancyData.occupancyrules));
  
  useEffect(() => {
    if (occupancyData && occupancyData.occupancyrules && occupancyData.occupancyrules.product_id === Number(id)) {
      const orData = JSON.parse(JSON.stringify(occupancyData.occupancyrules));
      const initialRates = Object.keys(orData).map((key) => (orData[key] || '').toString());
      setruleoccupancy((prevState) => ({
        ...prevState,
        id:id,
        minadult:orData.min_adult,
        maxadult:orData.max_adult,
        minchild:orData.min_child,
        maxchild:orData.max_child,
        mininfant:orData.min_infant,
        maxinfant:orData.max_infant,
      }));
    }
  }, [occupancyData, id]);


  console.log("teranamee",cancelData.cancelpolicies)


  
  
  // function loadPaxhealth(id){
  //   dispatch(getSinglePaxhealth(id));

  //   setpaxhealth({
  //       id:id,
  //       amiweight:pxData.adult_min_weight,
  //       amaweight:pxData.adult_max_weight,
  //       amiheight:pxData.adult_min_height,
  //       amaheight:pxData.adult_max_height,
  //       cmiweight:pxData.child_min_weight,
  //       cmaweight:pxData.child_max_weight,
  //       cmiheight:pxData.child_min_height,
  //       cmaheight:pxData.child_max_height,
  //       acp:pxData.child_permission,
  //       aip:pxData.infant_permission,
  //       aap:pxData.adult_permission,
  //       healthrestrictions:pxData?.health_restrictions,
  //       status2:pxData?.status,
  //   })
  // }

  console.log("phone",paxhealth)
  console.log("adult_min_height",pxData)
  








  function loadProduct(id){
    dispatch(getSingleProduct(id));
    setProducts({
        id:id,
        productname:pData.product_name,
        servicetypeid:pData.service_type_id,
        tourtypeid:pData.tour_type_id,
        phonenumber:pData.phone_number,
        cityid:pData.city_id,
        countryid:pData.country_id,
        reservationmailid:pData.reservation_email_id,
        locationid:pData.location_id,
        // dailystarttime:pData.daily_start_time,
        // dailyendtime:pData.daily_end_time,
        nooftrips:pData.no_of_trips,
        // dresscode:pData.dress_code,
        remarks:pData.remarks,
        itenarygroupid:pData.itenary_group_id,
        isdummy:pData.is_dummy,
        istricombo:pData.is_tricombo,
        isbulkticket:pData.is_bulkticket,
        hasvat:pData.has_vat,
        vouchertosbt:pData.voucher_to_sbt,
        hastax:pData.has_tax,
        productdescription:pData.product_description,
        status:pData.status
    });
  
    
 }


 function loadcheckbox(){
  dispatch(getSingleProduct(id));
 }

 const pData = JSON.parse(JSON.stringify(productData.pSDetails));
 

 
 const pIData = JSON.parse(JSON.stringify(productData.productsImage));

  const ProductRef = useRef(null);

  const [productname,setProductname]= useState('');
  const [amiweight2,setAmiWeight]= useState('');
  const [amaweight,setAmaWeight]= useState('');
  const [amiheight,setAmiHeight]= useState('');
  const [amaheight,setAmaHeight]= useState('');

  const [cmiweight,setCmiWeight]= useState('');
  const [cmaweight,setCmaWeight]= useState('');
  const [cmiheight,setCmiHeight]= useState('');
  const [cmaheight,setCmaHeight]= useState('');
  const [servicetypeid,setServicetypeid]= useState('');
  const [tourtypeid,setTourtypeid]= useState('');
  const [phonenumber,setPhonenumber]= useState('');
  const [cityid,setCityid]= useState('');
  const [countryid,setCountryid]= useState('');
  const [reservationmailid,setReservationmailid]= useState([]);
  const [locationid,setLocationid]= useState(0);
  const [dailystarttime,setDailystarttime]= useState('');
  const [supplierid,setSupplierid]= useState([]);
  const [dailyendtime,setDailyendtime]= useState('');
  const [nooftrips,setNooftrips]= useState('');
  const [dresscode,setDresscode]= useState('');
  const [remarks,setRemarks]= useState('');
  const [itenarygroupid,setItenarygroupid]= useState('');
  const [dayShow,setDayShow] = useState(false);
  const [timeShow,setTimeShow] = useState(false);
  
  const [perShow,setPerShow] = useState(false);
  const [minamtShow,setMinamtShow] = useState(false);


  
  const [productdescription,setProductdescription]= useState('');
  const [healthrestrictions,setHealthrestrictions]= useState('');
  const [status,setStatus]= useState('');
  const [status2,setStatus2]= useState('');

 
  //Image Upload
  const [files,setFiles]= useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [progressInfos, setProgressInfos] = useState([]);
  const [message, setMessage] = useState([]);
  const [imageInfos, setImageInfos] = useState([]);
  const [ageview,setAgeView] = useState(false);
  const [cancelpview,setCancelpView] = useState(false);
  const progressInfosRef = useRef(null);
  const fileref = useRef('');
   //Image Upload
  
  const [alertStatus, setAlertStatus] = useState('');
  const [tabHandle, setTabHandle] = useState('basic');
  // console.log(tabHandle)
  const { register, handleSubmit, formState: { errors } } = useForm();
  // console.log("errors",errors)
 
  const { piscLoading, pcstatus, pmmessage,productId ,pidmessage,productsImage,productimageall, pcMessage} = useSelector((state) => state.productList);
  // console.log("productimageall",productimageall)
  const { serviceType } = useSelector((state) => state.serviceTypiesList);
  const { tourType } = useSelector((state) => state.tourTypesList);
  const { reservationEmail } = useSelector((state) => state.reservationEmailsList);
  const { city } = useSelector((state) => state.citiesList);
  const { country } = useSelector((state) => state.countryList);



const handleageview = (e) => {
  setAgeView(!ageview)

};

const mystyle = {
 backgroundColor:'#00000040'
};

const mystyle2 = {
  backgroundColor:'white'
 };


 const mystyle3 = {
  color:'red'
 };
 
 const mystyle4 = {
   color:'black'
  };

const handlecancelview = (e) => {
 setCancelpView(!cancelpview)
  
};
const handleBefore = (e) =>{

  if(e == "Day"){
    setDayShow(true);
    setTimeShow(false)
  }else if(e == "Hour"){
    setTimeShow(true)
    setDayShow(false);
  }
  }


  const handlePercentage = (e) =>{

    if(e == "Percentage"){
      setPerShow(true);
      setMinamtShow(false)
    }else if(e == "Minamt"){
      setMinamtShow(true)
      setPerShow(false);
    }
    }

  const handleisdummy = (e) => {
    setProddisable(false);
  
 
     if (isdummy == true) {
      setIsdummy(false)
      setProducts({ ...products, isdummy: '0'});
      console.log('checked')

    } 
    else if(isdummy == false) {
      setIsdummy(true)
      console.log('notchecked')
      setProducts({ ...products, isdummy: '1' });
     

     
     
     
    } 


}

// const renderedProduct = productsImage.map(product => (
        
//   <tr key={product.id}>
//       <td>{product.product_id}</td>
//       {/* <td>{product.supplier_code}</td> */}
//        </tr>
// ))

const handleChangeSupplier = (evt, options) => {
  evt.persist();
  const lastAddedItem = options[options?.length -1];
  if (evt.target.checked) {setSupplierid([...supplierid,  lastAddedItem?.id]);} 
  else { removeSupplier(lastAddedItem?.id) } 
}

const removeSupplier = (id) => { setSupplierid([...supplierid?.filter((supplierid) =>
  supplierid == id)]) }


  const handleChangeREmail = (evt, options) => {
    evt.persist();
    const lastAddedItem = options[options?.length -1];
    if (evt.target.checked) {setReservationmailid([...reservationmailid,  lastAddedItem?.id]);} 
    else { removeREmail(lastAddedItem?.id) } 
}
  
  const removeREmail = (id) => { setReservationmailid([...reservationmailid.filter((supplierid) =>
    supplierid == id)]) }

  const handleistricombo = (e) => {
    if (istricombo == true) {
      setIstricombo(false)
      setProducts({ ...products, istricombo: '0'});

    } 
    else if(istricombo == false) {
      setIstricombo(true)
      setProducts({ ...products, istricombo: '1' });    
    } 

}

  const handleisbulkticket = (e) => {
    setProddisable(false);
 
    if (isbulkticket == true) {
      setIsbulkticket(false)
      setProducts({ ...products, isbulkticket: '0'});
      

    } 
    else if(isbulkticket == false) {
      setIsbulkticket(true)
      setProducts({ ...products, isbulkticket: '1' }); 
    } 


}

  const handlehasvat = (e) => {
    setProddisable(false);
    if (hasvat == true) {
      setHasvat(false)
      setProducts({ ...products, hasvat: '0'});

    } 
    else if(hasvat == false) {
      setHasvat(true)
      setProducts({ ...products, hasvat: '1' }); 
    } 


}

  const handlevouchertosbt = (e) => {
    setProddisable(false);
    if (vouchertosbt == true) {
      setVouchertosbt(false);
      setProducts({ ...products, vouchertosbt: '0' });
    } 
    else if(vouchertosbt == false){
      setVouchertosbt(true);
      setProducts({ ...products, vouchertosbt: '1' });
    } 

}

const onProductImageDelete = (id, e) => {
  e.preventDefault();
  Swal.fire({
      title: 'Are you sure want to delete this Image?',
      showDenyButton: true,
      icon:'error',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      }
    }).then((result) => {
      
      if (result.isConfirmed) {
        dispatch(productImageDeletion(id)).then(() => {
          dispatch(getAllProductImage()); 
          Swal.fire('Product Image Deleted Successfully!', '', 'success')
        })
    } else if (result.isDenied) {
        Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
      }
    })


}



  const handlehastax = (e) => {
    setProddisable(false);
    const checked = e.target.checked;
    if (hastax == true) {
      sethastax(false);
      setProducts({ ...products, hastax: '0' });
    } 
    else if(hastax == false) {
      sethastax(true);
      setProducts({ ...products, hastax: '1' });
    } 

}
useEffect(() => {
  dispatch(getSinglePaxhealth(id))
  dispatch(getSingleAgePolicy(id))
  dispatch(getSingleCancelPolicy(id));
  dispatch(getSingleOccupancyRule(id));
  dispatch(getAllProductImage());

}, [pmstatus,productagepolicymmessage,productcancelpolicymmesscancel,productoccupancyrulemmessage,pidmessage,pcMessage])




const handleacp = (e) => {
  setPaxdisable(false);
 
  if (paxhealth?.acp == true) {
    setIsacp(false);
    setpaxhealth({ ...paxhealth, acp: '0' });
  } 
  else if(paxhealth?.acp == false) {
    setIsacp(true);
    setpaxhealth({ ...paxhealth, acp: '1' });
  } 

}

const handleaip = (e) => {
  setPaxdisable(false);
 
  if (paxhealth?.aip == true) {
    setIsaip(false);
    setpaxhealth({ ...paxhealth, aip: '0' });
  } 
  else if(paxhealth?.aip == false) {
    setIsaip(true);
    setpaxhealth({ ...paxhealth, aip: '1' });
  } 

}

const handleaap = (e) => {
  setPaxdisable(false);
 
  if (paxhealth?.aap == true) {
    setIsaap(false);
    setpaxhealth({ ...paxhealth, aap: '0' });
  } 
  else if(paxhealth?.aap == false) {
    setIsaap(true);
    setpaxhealth({ ...paxhealth, aap: '1' });
  } 

}
  


  
  const handleCheckbox2 = (e) => {
    const checked = e.target.checked;
    if (e.target.name == "acp" && checked) {
      setIsacp(1);
    } 
    else if (e.target.name == "aip" && checked) {
      setIsaip(1);
    } 
    else if (e.target.name == "aap" && checked) {
      setIsaap(1);
    } 

    
  };
  
// console.log('pData',pData);
  useEffect(() => {
    dispatch(getAllServiceType());
    dispatch(getAllTourType());
    dispatch(getAllReservationEmail());
    dispatch(getAllCity());
    dispatch(getAllSupplier());
    dispatch(getAllCountry());
    dispatch(resetProductCreatiion());
    dispatch(getAllProductImage());
    

    return () => setIsAlive(false)
    
  }, [isAlive]);


  const handleOnSubmit = (e) => {
    setProddisable(true);
    e.preventDefault();
      setLocationid(0);
      const {
        id,
        productname,
        servicetypeid,
        tourtypeid,
        phonenumber,
        cityid,
        countryid,
        reservationmailid,
        locationid,
        // dailystarttime,
        // dailyendtime,
        nooftrips,
        // dresscode,
        remarks,
        itenarygroupid,
        isdummy,
        istricombo,
        isbulkticket,
        hasvat,
        vouchertosbt,
        hastax,
        productdescription,
        status

      } = products
      
    if (
  
      productname !== "" ||
      servicetypeid !== "" ||
      tourtypeid !== "" ||
      phonenumber !== "" ||
      cityid !== "" ||
      countryid !== "" ||
      isdummy !== "" ||
      isbulkticket !== "" ||
      hasvat !== "" ||
      hastax !== "" ||
      productdescription !== "" ||
      status !== ""


    ){

      
      
        const newProductCreation1 = {
            id,
            productname,
            servicetypeid,
            tourtypeid,
            phonenumber,
            cityid,
            countryid,
            reservationmailid,
            locationid,
            // dailystarttime,
            // dailyendtime,
            nooftrips,
            // dresscode,
            remarks,
            itenarygroupid,
            isdummy,
            istricombo,
            isbulkticket,
            hasvat,
            vouchertosbt,
            hastax,
            productdescription,
            status
	
          }

        dispatch(
            productModification(newProductCreation1)
        )
        navigate('/productList'); 

    }else{
      Swal.fire('No changes made!', '', 'warning');
    }
       
     
     
  }

  
  const handlePhoneChange = e => {
   
    // console.log('name ',e); 
    //console.log('value '+value); 
    setProducts({ ...products, "phonenumber": e });
    /* setRole(prevState => ({
      role:{
        ...prevState.role,
        [name]: value
      }
    })); */
  };

  const handleOnChange = e => {
    setProddisable(false);
    const name = e.target.name;
    const value = e.target.value;
    // console.log('name '+name); 
    //console.log('value '+value); 
    setProducts({ ...products, [name]: value });
    /* setRole(prevState => ({
      role:{
        ...prevState.role,
        [name]: value
      }
    })); */
  };
  // console.log("producccys",products)
  const handleOnChange2 = e => {
    setPaxdisable(false)
    const name = e.target.name;
    const value = e.target.value;
    setpaxhealth({ ...paxhealth, [name]: value });
 
  };


  const handleOnChange3 = e => {
    const name = e.target.name;
    const value = e.target.value;
    setpolicyage({ ...policyage, [name]: value });
 
  };

  const handleOnChange5 = e => {
    const name = e.target.name;
    const value = e.target.value;
    setruleoccupancy({ ...ruleoccupancy, [name]: value });
 
  };

  const handleOnChange4 = e => {
    const name = e.target.name;
    const value = e.target.value;
    setpolicycancel({ ...policycancel, [name]: value });
 
  };

  const handledst = date => {
    // console.log(moment(date).format('YYYY-MM-DD hh:mm:ss'))
    setDailystarttime(date)

    setProducts({ ...products, "dailystarttime": date});
  };

  const handledet = date => {
    setDailyendtime(date)

    setProducts({ ...products, "dailyendtime": date});
  };



  const handleOnSubmit2 = (e) => {
    setPaxdisable(true);
    e.preventDefault();

    const  {
        id,
        idd,
        amiweight2,
        amaweight,
        amiheight,
        amaheight,
        cmiweight,
        cmaweight,
        cmiheight,
        cmaheight,
        acp,
        aip,
        aap,
        healthrestrictions,
        status2,
        productId
      } = paxhealth;
        console.log("amiweight2",amiweight2) 
        console.log("amaweight",amaweight)
        console.log("amiheight",amiheight)
        console.log("amaheight",amaheight)
        console.log("cmiweight",cmiweight)
        console.log("cmaweight",cmaweight)
        console.log("cmiheight",cmiheight)
        console.log("cmaheight",cmaheight)
        console.log("acp",acp)
        console.log("aip",aip)
        console.log("aap",aap)
        console.log("healthrestrictions",healthrestrictions)
        console.log("status2",status2)

      if(amiweight2 !==  pxData.adult_min_weight || 
        amaweight !== pxData.adult_max_weight ||
        amiheight !== pxData.adult_min_height ||
        amaheight !== pxData.adult_max_height ||
        cmiweight !== pxData.child_min_weight ||
        cmaweight !== pxData.child_max_weight ||
        cmiheight !== pxData.child_min_height ||
        cmaheight !== pxData.child_max_height ||
        acp !== pxData.child_permission ||
        aip !== pxData?.infant_permission ||
        aap !== pxData?.adult_permission ||
        healthrestrictions !== pxData?.health_restrictions ||
        status2 !== pxData?.status 
        ){
          const newProductCreation2 = {
            id,
            idd,
            amiweight2,
            amaweight,
            amiheight,
            amaheight,
            cmiweight,
            cmaweight,
            cmiheight,
            cmaheight,
            acp,
            aip,
            aap,
            healthrestrictions,
            status2,
            productId
          }

        dispatch(
          paxhealthModification(newProductCreation2)
        )
        setIsAlive(true)
        Swal.fire({
          title: 'Success!',
          text: 'Pax And Health Details Updated Successfully',
          icon: 'success',
          confirmButtonText: 'Okay'
        })
        navigate('/productList'); 

        }else{
          Swal.fire('No changes made!', '', 'warning');
        }
   
       

    
       
     
  }

  const handleCbhours = (e) => {

    setpolicycancel({ ...policycancel, 'cbhours': e });
 
  }


  const handleOnSubmit3 = (e) => {
    e.preventDefault();
    const {
            id,
            idd,
            adultage,
            schildage,
            echildage,
            sinfantage,
            einfantage,
            productId

    } = policyage;
   
        const newProductCreation3 = {
            id,
            idd,
            adultage,
            schildage,
            echildage,
            sinfantage,
            einfantage,
            productId
          }

          const {
            iddp,
            idd2,
     
            sdate,
            edate,
            cbdays,
            cbhours,
            percentage,
            bdays,
            minamt,
            cremark,
          } = policycancel;

          const newProductCreation4 = {
            iddp,
            idd2,
            sdate,
            edate,
            cbdays,
            cbhours,
            percentage,
            bdays,
            minamt,
            cremark,
          }
         
          if(adultage !== apData?.adult_age || 
          schildage !== apData?.schild_age || 
          echildage !== apData?.echild_age || 
          sinfantage !== apData?.sinfant_age || 
          einfantage !== apData?.einfant_age || 
          sdate !== cpData?.start_date || 
          edate !== cpData?.end_date || 
          cbdays !== cpData?.cancel_within_days || 
          cbhours !== cpData?.cancel_within_hours || 
          percentage !== cpData?.percentage_amount || 
          bdays !== cpData?.buffer_days || 
          minamt !== cpData?.min_amount || cremark !== cpData?.remark
          ){
            dispatch(
              agepolicyModification(newProductCreation3)
            )
    
            dispatch(
              cancelpolicyModification(newProductCreation4)
            )
            Swal.fire({
              title: 'Success!',
              text: 'Policy Details Updated Successfully',
              icon: 'success',
              confirmButtonText: 'Okay'
            })
    
            navigate('/productList');
          }else{
            Swal.fire('No changes made!', '', 'warning');


          }


      
        
       
     
  }


  
  const handleOnSubmit4 = (e) => {
    e.preventDefault();
    const {
            id,
            idd,
            minadult,
            maxadult,
            minchild,
            maxchild,
            mininfant,
            maxinfant,
            productId

    } = ruleoccupancy;
   
        const newProductCreation5 = {
          id,
          idd,
          minadult,
          maxadult,
          minchild,
          maxchild,
          mininfant,
          maxinfant,
          productId
          }

          if(
            minadult !== orData?.min_adult ||
            maxadult !== orData?.max_adult ||
            minchild !== orData?.min_child ||
            maxchild !== orData?.max_child ||
            mininfant !== orData?.min_infant ||
            maxinfant !== orData?.max_infant 
            ){
              dispatch(
                occupancyruleModification(newProductCreation5)
              )
      
              Swal.fire({
                title: 'Success!',
                text: 'Occupancy Rule Details Updated Successfully',
                icon: 'success',
                confirmButtonText: 'Okay'
              })
      
              navigate('/productList');

            }else{
              Swal.fire('No changes made!', '', 'warning');

            }

         

          
       
       
     
  }

 /*const uploadMultipleFiles =(e) =>{
  this.fileObj.push(e.target.files)
  for (let i = 0; i < this.fileObj[0].length; i++) {
   this.fileArray.push(URL.createObjectURL(this.fileObj[0][i]))
    }
    setFiles({ file: this.fileArray })
    }*/
    const selectFiles = (event) => {
      setDisupload(false);
      let images = [];
      let selectedFiles = [];
    
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        if (file.type === 'image/webp') {
          images.push(URL.createObjectURL(file));
          selectedFiles.push(file);
        }
      }
    
      setSelectedFiles(selectedFiles);
      setImagePreviews(images);
      setProgressInfos([]);
      setMessage([]);
    };

    // const selectFiles = (event) => {
    //   let images = [];
  
    //   for (let i = 0; i < event.target.files.length; i++) {
    //     images.push(URL.createObjectURL(event.target.files[i]));
    //   }
    //   setSelectedFiles([]);
    //   setSelectedFiles(event.target.files);
    //   setImagePreviews(images);
    //   setProgressInfos([]);
    //   setMessage([]);
    //   // setIsAlive(true)
    // };
    //console.log(imagePreviews);

    // const uploadImages =  (e) => {
    //   e.preventDefault();
    //   if (selectedFiles.length==0) {
    //     // show an error message
    //     let failure_result= {
    //       message: "Please Select a image file",
         
    //     }
    //     dispatch(imageUploadFailureProcess(failure_result));
    //     setMessage([]);
    //     setProgressInfos([]);
    //     return;
    //   }
  
    // //    let _progressInfos = [];
    // //   console.log('vasa1',selectedFiles)
    // // for (let i = 0; i < selectedFiles.length; i++) {
    
    // //   _progressInfos.push({ percentage: 0, fileName: selectedFiles[i].name });
      
    // // }
    
    // // console.log('Hello-one',_progressInfos);

    // //setProgressInfos([]);
  
    //  //setProgressInfos(oldArray => [...oldArray, ..._progressInfos]);

    //   //setProgressInfos(_progressInfos);
    
    //   setMessage([]);
    //   // console.log('Hello',progressInfos);
    //  /* progressInfosRef.current = {
    //     val: _progressInfos,
    //   };*/

    //   //const uploadPromises =files.map((file, i) => upload(i, file));
    //   for (let i = 0; i < selectedFiles.length; i++) {
      
    //     upload(i,id, selectedFiles[i]);
    //   }
    //   fileref.current.value='';
    //   /*Promise.all(uploadPromises)
    //   .then(() => UploadService.getFiles())
    //   .then((files) => {
    //     setImageInfos(files.data);
    //   });

    //   setMessage([]);*/
    //   setIsAlive(true)
    // };
    const uploadImages = (e) => {
      setDisupload(true);
      e.preventDefault();
      if (selectedFiles.length === 0) {
        // show an error message
        let failure_result = {
          message: "Please Select an image file (Webp)",
        };
        Swal.fire("Image Upload Failed!!","Please Select an image file (Webp).",'error')
        dispatch(imageUploadFailureProcess(failure_result));
        setMessage([]);
        setProgressInfos([]);
        return;
      }
    
      setMessage([]);
    
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        
        if (file.size > 1024 * 1024) {
          // Show an error message for files larger than 1MB
          let failure_result = {
            message: "Selected image is too large. Please select an image under 1MB.",
          };
          Swal.fire("Image Upload Failed!!","Selected image is too large. Please select an image under 1MB.",'error')


          dispatch(imageUploadFailureProcess(failure_result));
          setMessage([]);
          setProgressInfos([]);
          return;
        }
        
        upload(i, id, file);
      }
      
      // Reset the file input value
      fileref.current.value = '';
    
      setIsAlive(true)
  };
    const upload = (idx,product_id, file) => {

      
      let _progressInfos = [...progressInfos];

   
      return UploadService.upload(file,product_id, (event) => {
        _progressInfos[idx].percentage = Math.round(
          (100 * event.loaded) / event.total
        );
        setProgressInfos(_progressInfos);
      })
        .then(() => {
          setMessage((prevMessage) => [
            ...prevMessage,
            "Image Updated Successfully: " + file.name,
          ]);
       
          let success_result= {
            message: "Image Updated Successfully",
            // id: id,
           
          }
          dispatch(imageuploadProcess(success_result));
        })
        .catch(() => {
          _progressInfos[idx].percentage = 0;
          setProgressInfos({ val: _progressInfos });
  
          setMessage((prevMessage) => [
            ...prevMessage,
            "Could not upload the image: " + file.name,
          ]);
        });

        
    };
    //console.log('imageupload message--',message);
    useEffect(() => {
      setIsdummy(pData?.is_dummy)
      setIstricombo(pData?.is_tricombo)
      setIsbulkticket(pData?.is_bulkticket)
      setHasvat(pData?.has_vat)
      setVouchertosbt(pData?.voucher_to_sbt)
      sethastax(pData?.has_tax)
      setIsacp(pxData?.child_permission)
      setIsaip(pxData?.infant_permission)
      setIsaap(pxData?.adult_permission)
    
    }, [pData?.is_dummy,pData?.is_tricombo,pData?.is_bulkticket,pData?.has_vat,pData?.voucher_to_sbt,pData?.has_tax,pxData?.child_permission,pxData?.infant_permission,pxData?.adult_permission])
    

    useEffect(() => {
      

     
     let objectLength = Object.keys(selectedFiles).length;
    //  console.log('Hello-inside useeffect1',objectLength);
     let _progressInfos = [];
     

if(objectLength>0)
{
      for (let i = 0; i < selectedFiles.length; i++) {
       _progressInfos.push({ percentage: 0, fileName: selectedFiles[i].name });
      }
    }   
    //  console.log('Hello-inside useeffect push aray2',_progressInfos);
     setProgressInfos([]);
       setProgressInfos([...progressInfos, ..._progressInfos]);

        //  console.log('Hello-inside useeffect new aray3',progressInfos);
         
     
    }, [selectedFiles]);

//   const canSave = Boolean (productname) && Boolean(servicetypeid) && Boolean(cityid) && Boolean(status) 
  const canFileupload = Boolean (productname) && Boolean(servicetypeid) && Boolean(tourtypeid) && Boolean(cityid) && Boolean(countryid) && Boolean(status) && Boolean(pmstatus)
//console.log(curstatus);
//console.log('msg');
//console.log(curmessage);
  //console.log(passwordError.confirmPassword);


  return (
    <>
    
      {/* <Container className="my-4 mx-4 container-xl ">

      <Card  style={{marginLeft:'100px',marginTop:'-60px'}}>
          <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2">Update Product</h4></Card.Header>
          <Card.Body>
            <Row>
            <Link to="/productList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link>  */}
               <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"  style={{fontFamily:'Times New Roman', fontWeight:'600' }}>Update Product</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/productList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
            <div>
           { productimageall.filter(obj => obj.product_id === parseInt(id)).length === 0 && <><ul><li style={{color:"red"}}>Please Add Images & Videos</li></ul></>}
           { paxhealth?.id == '' && <><ul><li style={{color:"red"}}>Please Add Pax & Health Details</li></ul></>}
           { policyage?.id == '' && <><ul><li style={{color:"red"}}>Please Add Age Policy Details</li></ul></>}
           { policycancel?.iddp == '' && <><ul><li style={{color:"red"}}>Please Add Cancel Policy Details</li></ul></>}
           { ruleoccupancy?.id == '' && <><ul><li style={{color:"red"}}>Please Add Occupancy Rule Details</li></ul></>}
            </div>

            </Row>
            <br />
            <Tabs
      defaultActiveKey='basic'
    //   activeKey='basic'
      id="justify-tab-example"
      className="mb-3"
      justify
    >
      <Tab eventKey="basic" title="Basic Details ">
      <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit(e))}> {/* handleOnSubmit() */}
      <Form.Control type="hidden" name="id" autoComplete='off' value={id} />
<Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Name <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="text" ref={ProductRef}  name="productname" required="true" value={products.productname} autoComplete='off' placeholder="Enter Product Name" {...register("productname", { required: true, mixLength: 3 })}  onChange={handleOnChange}/>
    {errors.productname && <p className='text-danger'> Product Name required</p>}
  </Form.Group>
 
  <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Phone No <span className='text-danger'>*</span></Form.Label>
    <PhoneInput
    className='form-control'
    placeholder="Enter phone number"
    required={true}
    defaultCountry="IN" // Set the default country to India
    value={products.phonenumber}
    ref={ProductRef} 
    {...register("mobile", { required: true })}
    name="phonenumber"
    onChange={handlePhoneChange}
    onBlur={() => {
      try {
        const phoneNumber = parsePhoneNumber(products.phonenumber);
        if (!phoneNumber || !phoneNumber.isValid()) {
          setPhonenumber();
          Swal.fire({
            title: 'error!',
            text: 'Please Enter Valid Number',
            icon: 'error',
            confirmButtonText: 'Okay'
          })

        }
        // if (phoneNumber.country === 'IN' && phoneNumber.nationalNumber.length !== 10) {
        //   throw new Error('Phone number must be 10 digits for India');
        // }
      } catch (error) {
        // console.error(error);
        // Handle the validation error, e.g., set an error state
      }
    }}
  />
    {/* <Form.Control type="text" ref={ProductRef}  name="phonenumber" required="true" value={products.phonenumber ? products.phonenumber : pData.phone_number} autoComplete='off' placeholder="Enter Mobile No" {...register("phonenumber", { required: true, mixLength: 3 })}  onChange={handleOnChange}/> */}
    {/* <PhoneInput className='form-control' placeholder="Enter phone number" required="true" style={{height:"38px",border:""}} value={products.phonenumber ? products.phonenumber : pData.phone_number} ref={ProductRef} {...register("phonenumber", { required: true, mixLength: 3 })}  onChange={handlePhoneChange} name="phonenumber" /> */}

    {errors.phonenumber && <p className='text-danger'> Phone No required</p>}
  </Form.Group>
  </Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridServiceType">
    <Form.Label>Service <span className='text-danger'>*</span></Form.Label>
    <Form.Select value={products.servicetypeid ? products.servicetypeid : pData.service_type_id}  name="servicetypeid" required="true" onChange={handleOnChange}>
    <option  value="" >Choose</option>
      {serviceType.map((service,index) =>
    
      <option key={service.id} value={service.id}  >{service.service_type}</option>
      )}
    </Form.Select>
    </Form.Group>
    <Form.Group as={Col} controlId="formGridServiceType">
    <Form.Label>Tour Type <span className='text-danger'>*</span></Form.Label>
    <Form.Select  name="tourtypeid" value={products.tourtypeid ? products.tourtypeid : pData.tour_type_id}  required="true" onChange={handleOnChange}>
    <option  value="" >Choose</option>
      {tourType.map((tour,index) =>
    
      <option key={tour.id} value={tour.id} >{tour.tour_type}</option>
      )}
    </Form.Select>
    </Form.Group>
</Row>
<Row className="mb-3">
<Form.Group as={Col} controlId="formGridServiceType">
    <Form.Label>Country <span className='text-danger'>*</span></Form.Label>
    <Form.Select  name="countryid" value={products.countryid ? products.countryid : pData.country_id} required="true" onChange={handleOnChange}>
    <option  value="" >Choose</option>
      {country.map((countries,index) =>
    
      <option key={countries.id} value={countries.id} >{countries.country_name}</option>
      )}
    </Form.Select>
    </Form.Group>
    <Form.Group as={Col} controlId="formGridServiceType">
    <Form.Label>City <span className='text-danger'>*</span></Form.Label>
    <Form.Select value={products.cityid ? products.cityid : pData.city_id}   name="cityid" required="true" onChange={handleOnChange}>
    <option  value="" >Choose</option>
      {city.map((citiess,index) =>
    
      <option key={citiess.id} value={citiess.id} >{citiess.city_name}</option>
      )}
    </Form.Select>
    </Form.Group>
  </Row>
  {/* <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridDialyStartTime">
  <Form.Label>Daily Start Time  </Form.Label>
  <Datetime initialViewMode="time" name="dailystarttime" value={products.dailystarttime ? products.dailystarttime :  moment(pData.daily_start_time).format('hh:mm A')}  updateOnView="time" dateFormat={false} timeFormat="HH:mm A" {...register("dailystarttime", { required: true, mixLength: 3 })}  selected={dailystarttime} onChange={(e)=>{handledst(e)}} />
    </Form.Group>

    <Form.Group as={Col} controlId="formGridDialyEndTime">
    <Form.Label>Daily End Time </Form.Label>
    <Datetime initialViewMode="time" name="dailyendtime" value={products.dailyendtime ? products.dailyendtime :  moment(pData.daily_end_time).format('hh:mm A')} updateOnView="time" dateFormat={false} timeFormat="HH:mm A" {...register("dailyendtime", { required: true, mixLength: 3 })}  selected={dailyendtime} onChange={(e)=>{handledet(e)}} />
   
    </Form.Group>
  </Row> */}
  <Row className="mb-3">
  

  </Row>


  <Row className="mb-3">
  {/* <Form.Group as={Col} controlId="formGridAddress1">
    <Form.Label>Suppliers</Form.Label>
    
     <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      options={suppliers}
      limitTags={1}
      disableCloseOnSelect
      style={{height:"38px"}}
      value={products?.supplierid ? products?.supplierid : pData?.supplier_id}
      getOptionLabel={(option) => option?.supplier_name}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 ,height:"38px"}}
            checked={selected}
        
          />
          {option?.supplier_name}
        </li>
      )}
      onChange={(e, options)=>{handleChangeSupplier(e, options)}}
   
      
      // style={{height:"38px" }}
      renderInput={(params) => (
        <TextField {...params} style={{height:"38px"}} label="" placeholder="Tag Suppliers" />
      )}
    />
     </Form.Group> */}
<br />
{/* 
    <Form.Group as={Col} controlId="formGridReservationEmail">
    <Form.Label>Reservation Email(s)<span className='text-danger'>*</span></Form.Label>

    <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      options={reservationEmail}
      limitTags={1}
       name="reservationemailid"
      disableCloseOnSelect
      value={products?.reservationmailid ? products?.reservationmailid : pData?.reservation_mail_id}
      style={{height:"38px"}}
      getOptionLabel={(option) => option?.reservation_email}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 ,height:"38px"}}
            checked={selected}
        
          />
          {option?.reservation_email}
        </li>
      )}
      onChange={(e, options)=>{handleChangeREmail(e, options)}}
   
      
      // style={{height:"38px" }}
      renderInput={(params) => (
        <TextField {...params} style={{height:"38px"}} label="" placeholder="Add Reservation Email" />
      )}
    />
     
  </Form.Group> */}
 
 
  </Row>
  <br />
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridIsdummy">
{console.log("ismmy",pData.is_dummy)}
{console.log("ismmy222",isdummy)}
  
  <Form.Check type="checkbox" ref={ProductRef} value={pData.is_dummy} checked={isdummy} name="isdummy"  label="Is Dummy Product?"  {...register("isdummy", { required: true, mixLength: 3 })}  onChange={handleisdummy} />
 
</Form.Group> 
<Form.Group as={Col} controlId="formGridHastax">
  
  <Form.Check type="checkbox" ref={ProductRef} value={pData.has_tax} name="hastax"  label="Has TAX?" checked={hastax}  {...register("hastax", { required: true, mixLength: 3 })}  onChange={handlehastax} />
 
</Form.Group> 
  </Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridIsbulkticket">
  
  <Form.Check type="checkbox" ref={ProductRef} value={pData.is_bulkticket}  checked={isbulkticket}  name="isbulkticket"  label="Bulk Ticket Purchase Permitted? "  {...register("isbulkticket", { required: true, mixLength: 3 })}  onChange={handleisbulkticket} />
 
</Form.Group> 
<Form.Group as={Col} controlId="formGridHasvat">
  
  <Form.Check type="checkbox" ref={ProductRef} value={pData.has_vat} name="hasvat"  label="Has Vat?" checked={hasvat}  {...register("hasvat", { required: true, mixLength: 3 })}  onChange={handlehasvat} />
 
</Form.Group> 
  </Row>
  <Row className="mb-3">
  

  </Row>
  <Row className="mb-3">
  {/* <Form.Group as={Col} controlId="formGridDresscode">
    <Form.Label>Dress Code</Form.Label>

    <Form.Control type="text" ref={ProductRef}  name="dresscode" autoComplete='off' value={products.dresscode ? products.dresscode : pData.dress_code} placeholder="Enter Dress Code" {...register("dresscode", { required: true, mixLength: 3 })}  onChange={handleOnChange}/>
    {errors.dresscode && <p className='text-danger'>Dress Code required</p>}
  </Form.Group> */}

  <Form.Group as={Col} controlId="formGridStatus">
    <Form.Label>Status <label className='text-danger'>*</label></Form.Label>
        <Form.Select required value={products.status ? products.status : pData.status}  name="status" {...register("status" , { required: true })} onChange={handleOnChange}>
          
          <option value="">Choose..</option>
          <option value="1">Enable</option>
          <option value="0">Disable</option>
        </Form.Select>
        {errors.status && <p className='text-danger'>Status required</p>}
      </Form.Group>
  </Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductdescription">
  <Form.Label>Description</Form.Label>
  
   <DefaultEditor rows="5"  ref={ProductRef}  value={products.productdescription ? products.productdescription : pData.product_description}  name="productdescription" {...register("productdescription", { required: true, mixLength: 3 })}  onChange={handleOnChange}
    />

</Form.Group>


</Row>
<div class="d-grid  col-2 mx-auto">
<Button variant="primary" disabled={proddisable} type="submit" className='align-middle' >
<FontAwesomeIcon icon={faRightToBracket} /> Update
</Button>
</div>
{/* {piscLoading && (<Spinner variant='info' animation='border' />)} */}

</Form>
      </Tab>
      {/* {console.log("productData?ii",Object.keys(productData.productsImage).length)} */}
              <Tab eventKey="images" title="Images & Videos" style={
                productimageall.filter(obj => obj.product_id === parseInt(id)).length === 0
                  ? mystyle
                  : mystyle2
              }>
      
      <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(uploadImages(e))}>
<div className="form-group multi-preview">
<Container>
          <Row xs={1} md={4}>
{productimageall?.filter(obj => obj.product_id == id)?.map((item)=>{
  return (
    <>

          <Col style={{marginLeft:"20px",marginBottom:"20px",marginRight:"40px"}}>
            <Card key={item.id} style={{marginTop:"20px",paddingRight:"30px",width:"250px",backgroundImage: `url(https://testapi.royalarabian.com/uploads/actions/${encodeURIComponent(item.product_image)})`,backgroundSize:'cover'}}>
            <Card.Body>
              <Card.Title><Button className="btn btn-sm btn-danger" style={{marginLeft:"100%"}} onClick={(e) => onProductImageDelete(item.id, e)}><FaTrash className='fwcolor' /></Button></Card.Title>
              <Card.Subtitle className="mb-2 text-muted"></Card.Subtitle>
              <Card.Title
               variant="top"
              //  src={"http://localhost:34567/uploads/actions/" + item.product_image}
               style={{width:"150px",height:"100px"}}
                
              // <img src={"http://localhost:34567/uploads/actions/" + item.product_image} width="350px" height="150px" alt="..." />
              />
                        
            </Card.Body>
          </Card>
        </Col>
       
      
   
    </>
    
  )
})}
   </Row>
      </Container> 

</div>
<br />
<div className="form-group">
<input type="file" className="form-control" onChange={(e) => selectFiles(e)}  multiple     accept="image/webp" ref= {fileref} />
<input type="hidden" name="productid" id="productid" value={id}/>
</div>
<br />
<Button type="submit" className="btn btn-danger btn-block" disabled={disupload}     >Upload</Button><br /><br/>
</Form>
 {progressInfos &&
          progressInfos.map((progressInfo, index) => (
            <div className="mb-2" key={index}>
              <span>{progressInfo.fileName}</span>
              <div className="progress">
                <div
                  className="progress-bar progress-bar-info"
                  role="progressbar"
                  aria-valuenow={progressInfo.percentage}
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: progressInfo.percentage + "%" }}
                >
                  {progressInfo.percentage}%
                </div>
              </div>
            </div>
          ))}  

{message.length > 0 && (
          <div className="alert alert-secondary" role="alert">
            <ul>
              {message.map((item, i) => {
                return <li key={i}>{item}</li>;
              })}
            </ul>
          </div>
        )}
              </Tab> 
              <Tab eventKey="longer-tab" title="Pax and Health" style={
               paxhealth?.id == ''
                  ? mystyle3
                  : mystyle4
              }>
                <Form className=" mx-4 my-2" component="form" noValidate autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit2(e))}> {/* handleOnSubmit() */}
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridIsacp">
{console.log("paxhealth?.acp",paxhealth?.acp)}
                      <Form.Check type="checkbox" ref={ProductRef} value={paxhealth?.acp || ''} name="acp" checked={Number(paxhealth?.acp)} label="Are Children Permitted ?"  {...register("acp", { required: true, mixLength: 3 })} onChange={(e) => handleacp(e)} />

                    </Form.Group>
                    <Form.Group as={Col} controlId="formGridIsaip">

                      <Form.Check type="checkbox" ref={ProductRef} value={paxhealth?.aip || ''} name="aip" checked={Number(paxhealth?.aip)} label="Are Infants Permitted ?"  {...register("aip", { required: true, mixLength: 3 })} onChange={(e) => handleaip(e)} />

                    </Form.Group>

                    <Form.Group as={Col} controlId="formGridIsaap">

                      <Form.Check type="checkbox" ref={ProductRef} value={paxhealth?.aap || ''} name="aap" checked={Number(paxhealth?.aap)} label="Are Adults Permitted ?"  {...register("aap", { required: true, mixLength: 3 })} onChange={(e) => handleaap(e)} />

                    </Form.Group>

                  </Row>
                  <hr />

                  <input type="hidden" name="id" id="id" value={id} />
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridProductName">
                      {console.log("paxhealth.amiheight", paxhealth.amiheight)}
                      {console.log("pxData.adult_min_height", pxData.adult_min_height)}
                      <Form.Label> Adult Minimum Height (cm) <span className='text-danger'>*</span></Form.Label>
                      <Form.Control type="number" min="1" max="300" ref={ProductRef} disabled={paxhealth?.aap == 1 || paxhealth?.aap == true ? 0 : 1} name="amiheight" value={paxhealth?.amiheight || ''} required="true" autoComplete='off' placeholder="Adult Minimum Height (cm)" {...register("amiheight", { required: true, mixLength: 3 })} onChange={handleOnChange2} 
                       onInput={(event) => {
                        let inputValue = parseInt(event.target.value);
                        if (isNaN(inputValue)) {
                          event.target.value = '';
                        } else {
                          inputValue = Math.max(1, Math.min(300, inputValue));
                          event.target.value = inputValue;
                        }
                      }}
                      
                      />
                      {errors.amih && <p className='text-danger'> Adult Minimum Height  required</p>}
                    </Form.Group>

                    <Form.Group as={Col} controlId="formGridMobile">
                      <Form.Label>Adult Maximum Height (cm) <span className='text-danger'></span></Form.Label>
                      <Form.Control type="number" min={paxhealth?.amiheight} max="300" ref={ProductRef} name="amaheight" disabled={paxhealth?.aap == 1 || paxhealth?.aap == true ? 0 : 1} required="true" value={paxhealth?.amaheight || ''} autoComplete='off' placeholder="Adult Maximum Height (cm)" {...register("amaheight", { required: true, mixLength: 3 })} onChange={handleOnChange2} 
                      onInput={(event) => {
                        let inputValue = parseInt(event.target.value);
                        if (isNaN(inputValue)) {
                          event.target.value = '';
                        } else {
                          inputValue = Math.max(paxhealth?.amiheight, Math.min(300, inputValue));
                          event.target.value = inputValue;
                        }
                      }}
                      />
                      {errors.amah && <p className='text-danger'> Adult Maximum Height  required</p>}
                    </Form.Group>
                  </Row>

                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridProductName">
                      <Form.Label>Adult Minimum Weight (kg) <span className='text-danger'></span></Form.Label>
                      <Form.Control type="number" min="1" max="300" ref={ProductRef} disabled={paxhealth?.aap == 1 || paxhealth?.aap == true ? 0 : 1} name="amiweight2" value={paxhealth?.amiweight2 || ''} required="true" autoComplete='off' placeholder="Adult Minimum Weight (kg)" {...register("amiweight2", { required: true, mixLength: 3 })} onChange={handleOnChange2}
                      onInput={(event) => {
                        let inputValue = parseInt(event.target.value);
                        if (isNaN(inputValue)) {
                          event.target.value = '';
                        } else {
                          inputValue = Math.max(1, Math.min(300, inputValue));
                          event.target.value = inputValue;
                        }
                      }}
                      />
                      {errors.amaw && <p className='text-danger'> Adult Minimum Weight  required</p>}

                      {/* <Form.Label> Adult Minimum Weight (kg) <span className='text-danger'>*</span></Form.Label>
                          <Form.Control type="number" min="0" ref={ProductRef} disabled={aap == 1 || aap == true ? 0 : 1}  name="amiweight" value={paxhealth?.amiweight || ''} required="true" autoComplete='off' placeholder="Adult Minimum Weight (kg)" {...register("amiweight", { required: true, mixLength: 3 })}  onChange={handleOnChange2}/>
                          {errors.amiw && <p className='text-danger'> Adult Minimum Weight  required</p>} */}
                    </Form.Group>

                    <Form.Group as={Col} controlId="formGridMobile">
                      <Form.Label>Adult Maximum Weight (kg) <span className='text-danger'></span></Form.Label>
                      <Form.Control type="number" min={paxhealth?.amiweight2} max="300" ref={ProductRef} disabled={paxhealth?.aap == 1 || paxhealth?.aap == true ? 0 : 1} name="amaweight" value={paxhealth?.amaweight || ''} required="true" autoComplete='off' placeholder="Adult Maximum Weight (kg)" {...register("amaweight", { required: true, mixLength: 3 })} onChange={handleOnChange2} 
                      onInput={(event) => {
                        let inputValue = parseInt(event.target.value);
                        if (isNaN(inputValue)) {
                          event.target.value = '';
                        } else {
                          inputValue = Math.max(paxhealth?.amiweight2, Math.min(300, inputValue));
                          event.target.value = inputValue;
                        }
                      }}
                      />
                      {errors.amaw && <p className='text-danger'> Adult Maximum Weight  required</p>}
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridProductName">
                      <Form.Label> Child Minimum Height (cm) <span className='text-danger'></span></Form.Label>
                      <Form.Control type="number" min="1" max="300" ref={ProductRef} disabled={paxhealth?.acp == 1 || paxhealth?.acp == true ? 0 : 1} name="cmiheight" value={paxhealth?.cmiheight || ''} required="true" autoComplete='off' placeholder="Child Minimum Height (cm)" {...register("cmiheight", { required: true, mixLength: 3 })} onChange={handleOnChange2} 
                      onInput={(event) => {
                        let inputValue = parseInt(event.target.value);
                        if (isNaN(inputValue)) {
                          event.target.value = '';
                        } else {
                          inputValue = Math.max(1, Math.min(300, inputValue));
                          event.target.value = inputValue;
                        }
                      }}
                      />
                      {errors.cmih && <p className='text-danger'>Child Minimum Height (cm)  required</p>}
                    </Form.Group>

                    <Form.Group as={Col} controlId="formGridMobile">
                      <Form.Label>Child Maximum Height (cm) <span className='text-danger'></span></Form.Label>
                      <Form.Control type="number" min={paxhealth?.cmiheight} max="300" disabled={paxhealth?.acp == 1 || paxhealth?.acp == true ? 0 : 1} ref={ProductRef} name="cmaheight" value={paxhealth?.cmaheight || ''} required="true" autoComplete='off' placeholder="Child Maximum Height (cm)" {...register("cmaheight", { required: true, mixLength: 3 })} onChange={handleOnChange2} 
                      onInput={(event) => {
                        let inputValue = parseInt(event.target.value);
                        if (isNaN(inputValue)) {
                          event.target.value = '';
                        } else {
                          inputValue = Math.max(paxhealth?.cmiheight, Math.min(300, inputValue));
                          event.target.value = inputValue;
                        }
                      }}
                      />
                      {errors.cmah && <p className='text-danger'>Child Maximum Height (cm)  required</p>}
                    </Form.Group>
                  </Row>

                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridProductName">
                      <Form.Label> Child Minimum Weight (kg) <span className='text-danger'></span></Form.Label>
                      <Form.Control type="number" min="1" max="300" disabled={paxhealth?.acp == 1 || paxhealth?.acp == true ? 0 : 1} ref={ProductRef} name="cmiweight" required="true" value={paxhealth?.cmiweight || ''} autoComplete='off' placeholder="Child Minimum Weight (kg)" {...register("cmiweight", { required: true, mixLength: 3 })} onChange={handleOnChange2} 
                      onInput={(event) => {
                        let inputValue = parseInt(event.target.value);
                        if (isNaN(inputValue)) {
                          event.target.value = '';
                        } else {
                          inputValue = Math.max(1, Math.min(300, inputValue));
                          event.target.value = inputValue;
                        }
                      }}
                      />
                      {errors.cmiw && <p className='text-danger'>Child Minimum Weight (kg)  required</p>}
                    </Form.Group>

                    <Form.Group as={Col} controlId="formGridMobile">
                      <Form.Label>Child Maximum Weight (kg) <span className='text-danger'></span></Form.Label>
                      <Form.Control type="number" min={paxhealth?.cmiweight} max="300" disabled={paxhealth?.acp == 1 || paxhealth?.acp == true ? 0 : 1} ref={ProductRef} name="cmaweight" required="true" value={paxhealth?.cmaweight || ''} autoComplete='off' placeholder="Child Maximum Weight (kg)" {...register("cmaweight", { required: true, mixLength: 3 })} onChange={handleOnChange2} 
                      onInput={(event) => {
                        let inputValue = parseInt(event.target.value);
                        if (isNaN(inputValue)) {
                          event.target.value = '';
                        } else {
                          inputValue = Math.max(paxhealth?.cmiweight, Math.min(300, inputValue));
                          event.target.value = inputValue;
                        }
                      }}
                      
                      />
                      {errors.cmaw && <p className='text-danger'>Child Maximum Weight (kg)  required</p>}
                    </Form.Group>
                  </Row>


                  <Form.Group as={Col} controlId="formGridStatus">
                    {console.log("sttttt",paxhealth?.status2)}
                    <Form.Label>Status <label className='text-danger'></label></Form.Label>
                    <Form.Select value={paxhealth?.status2} required name="status2" {...register("status2", { required: true })} onChange={handleOnChange2}>

                      <option value="">Choose..</option>
                      <option value="1" selected>Enable</option>
                      <option value="0">Disable</option>
                    </Form.Select>
                    {errors.status && <p className='text-danger'>Status required</p>}
                  </Form.Group>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridProductdescription">
                      <Form.Label>Health Restrictions</Form.Label>

                      <DefaultEditor rows="5" ref={ProductRef} value={paxhealth?.healthrestrictions || ''} name="healthrestrictions" {...register("healthrestrictions", { required: true, mixLength: 3 })} onChange={handleOnChange2}
                      />

                    </Form.Group>


                  </Row>
                  <div class="d-grid  col-2 mx-auto">
                    <Button variant="primary" disabled={paxdisable} type="submit" className='align-middle' >
                      <FontAwesomeIcon icon={faRightToBracket} /> Update
                    </Button>
                  </div>
                  {/* {piscLoading && (<Spinner variant='info' animation='border' />)} */}

                </Form>
              </Tab>
      <Tab eventKey="age-policy" title="Policies">
      
      <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit3(e))}> {/* handleOnSubmit() */}
      <input type="hidden" name="id" id="id" value={id}/>
      <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridIsdummy">
  
  <Form.Check type="checkbox" ref={ProductRef}  name="ageview"  label="Age Policy"  onChange={handleageview}  style={
               policyage?.id == ''
                  ? mystyle3
                  : mystyle4
              } />
 
</Form.Group> 

</Row>

      {ageview && ( <><Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Adult Age (Above) <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="1" max="300" ref={ProductRef} value={policyage?.adultage || '' } name="adultage" required="true" disabled={pxData.adult_permission? !pxData.adult_permission : !prmdata?.aap}  autoComplete='off' placeholder="Age Above" {...register("adultage", { required: true, mixLength: 3 })}  onChange={handleOnChange3}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(1, Math.min(300, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
    {errors.adultage && <p className='text-danger'> Adult Age required</p>}
  </Form.Group>
 
 
  </Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Child Age (Start) <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="1" max="17" ref={ProductRef}  name="schildage" value={policyage?.schildage || ''} required="true" disabled={pxData.child_permission ? !pxData.child_permission : !prmdata?.acp} autoComplete='off' placeholder="Enter child start age" {...register("schildage", { required: true, mixLength: 3 })}  onChange={handleOnChange3}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(1, Math.min(17, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
    {errors.schildage && <p className='text-danger'> Start Child Age required</p>}
  </Form.Group>

  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Child Age (End) <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min={policyage?.schildage} max="17" ref={ProductRef}  name="echildage"  required="true" autoComplete='off' value={policyage?.echildage || ''} disabled={pxData.child_permission ? !pxData.child_permission : !prmdata?.acp} placeholder="Enter child end age" {...register("echildage", { required: true, mixLength: 3 })}  onChange={handleOnChange3}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(policyage?.schildage, Math.min(17, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
    {errors.schildage && <p className='text-danger'> Start Child Age required</p>}
  </Form.Group>
 
 
  </Row>


  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Infant Age (Start) <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="0" max="6" ref={ProductRef}   name="sinfantage" required="true" value={policyage?.sinfantage || ''} disabled={pxData.infant_permission ? !pxData.infant_permission : !prmdata?.aip} autoComplete='off' placeholder="Enter infant start age" {...register("sinfantage", { required: true, mixLength: 3 })}  onChange={handleOnChange3}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(0, Math.min(6, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
    {errors.schildage && <p className='text-danger'> Start Infant Age required</p>}
  </Form.Group>

  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Infant Age (End) <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min={policyage?.sinfantage} max="6" ref={ProductRef}   name="einfantage" required="true" value={policyage?.einfantage || ''} disabled={pxData.infant_permission ? !pxData.infant_permission : !prmdata?.aip} autoComplete='off' placeholder="Enter infant end age" {...register("einfantage", { required: true, mixLength: 3 })} onChange={handleOnChange3}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(policyage?.sinfantage, Math.min(6, inputValue));
        event.target.value = inputValue;
      }
    }}
    />
    {errors.schildage && <p className='text-danger'> Start Infant Age required</p>}
  </Form.Group>
 
 
  </Row>
</>)}
<hr />
<Row className="mb-3">

<Form.Group as={Col} controlId="formGridIstricombo2">
  
  <Form.Check type="checkbox" ref={ProductRef}  name="cancelview"  label="Cancellation Policy"  onChange={handlecancelview} style={
               policycancel?.iddp == ''
                  ? mystyle3
                  : mystyle4
              }/>
 
</Form.Group> 
  </Row>

{cancelpview && ( <>

  <Row className="mb-3">
<Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Start Date<span className='text-danger'>*</span></Form.Label>
    <Form.Control type="date" ref={ProductRef} value={policycancel?.sdate || ''} name="sdate" min={new Date().toISOString().split('T')[0]}  required="true" autoComplete='off' placeholder="Enter the start date" {...register("sdate", { required: true, mixLength: 3 })}  onChange={handleOnChange4}/>
  </Form.Group>
  <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>End Date<span className='text-danger'>*</span></Form.Label>
    <Form.Control type="date" ref={ProductRef} value={policycancel?.edate || ''} min={policycancel?.sdate}   name="edate" required="true" autoComplete='off' placeholder="Enter the end date" {...register("edate", { required: true, mixLength: 3 })}  onChange={handleOnChange4}/>
  </Form.Group>
  
  </Row>

  <Row className="mb-3">
  {/* <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Cancel Before Days<span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" value={policycancel.cbdays ? policycancel.cbdays : cpData.cancel_within_days}  ref={ProductRef}  name="cbdays" required="true" autoComplete='off' placeholder="Enter The Number of Days" {...register("cbdays", { required: true, mixLength: 3 })}  onChange={handleOnChange4}/>
  </Form.Group> */}
  {/* <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Cancel Before Hours<span className='text-danger'>*</span></Form.Label>
    <Datetime initialViewMode="time" value={policycancel.cbhours ? policycancel.cbhours : moment(cpData.cancel_within_hours).format('HH:mm')}  name="cbhours" {...register("cbhours", { required: true, mixLength: 3 })} updateOnView="time" dateFormat={false} timeFormat="HH:mm" onChange={handleCbhours} />
  </Form.Group> */}
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Refund Rule <span className='text-danger'>*</span></Form.Label>
    <Form.Select required name="before" value={policycancel?.cbdays !== '' ? 'Day' : 'Hour' } {...register("before" , { required: true })} onChange={(e) => handleBefore(e.target.value)}>
          
          <option value="">Choose..</option>
          <option value="Day">Day</option>
          <option value="Hour">Hour</option>
        </Form.Select>  </Form.Group>
        {policycancel?.cbdays !== null && (<> <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Cancel Before Days<span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="0" max="100" ref={ProductRef}  name="cbdays" value={policycancel?.cbdays  || ''} required="true" autoComplete='off' placeholder="Enter The Number of Days" {...register("cbdays", { required: true, mixLength: 3 })}  onChange={handleOnChange4}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(1, Math.min(100, inputValue));
        event.target.value = inputValue;
      }
    }}
    />
  </Form.Group></>)}
 
  {policycancel?.cbhours !== null && ( <><Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Cancel Before Hours <span className='text-danger'>*</span></Form.Label>
    <Datetime initialViewMode="time" value={ moment(policycancel?.cbhours).format('HH:mm') || ''} name="cbhours" {...register("cbhours", { required: true, mixLength: 3 })} updateOnView="time" dateFormat={false} timeFormat="HH:mm" onChange={handleCbhours} />
  </Form.Group></>)}

  </Row>




  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Refund Policy <span className='text-danger'>*</span></Form.Label>
    <Form.Select required name="per" value={policycancel?.percentage !== '' ? 'Percentage' : 'Minamt' } {...register("per" , { required: true })} onChange={(e) => handlePercentage(e.target.value)}>
          
          <option value="">Choose..</option>
          <option value="Percentage">Percentage</option>
          <option value="Minamt">Minimum Amount</option>
        </Form.Select>  </Form.Group>
 {perShow == true && <> <Form.Group as={Col} controlId="formGridMobile">
 <Form.Label>Percentage<span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="0" value={policycancel?.percentage || ''}  ref={ProductRef}  name="percentage" required="true" autoComplete='off' placeholder="Enter the percentage" {...register("percentage", { required: true, mixLength: 3 })}  onChange={handleOnChange4}/>
  </Form.Group></>}
 
{minamtShow == true && <> <Form.Group as={Col} controlId="formGridMobile">
<Form.Label>Min Amount<span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="0" ref={ProductRef} value={policycancel?.minamt || ''}  name="minamt" required="true" autoComplete='off' placeholder="Enter Minimum Amount" {...register("minamt", { required: true, mixLength: 3 })}  onChange={handleOnChange4}/>
  </Form.Group></>}
  </Row>

 

  <Row className="mb-3">

  <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Buffer Days<span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number"  min="0" ref={ProductRef} value={policycancel?.bdays || ''}  name="bdays" required="true" autoComplete='off' placeholder="Enter Buffer Days" {...register("bdays", { required: true, mixLength: 3 })}  onChange={handleOnChange4}/>
  </Form.Group>


  <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Remarks<span className='text-danger'>*</span></Form.Label>
    <Form.Control as="textarea" rows={3} type="number" ref={ProductRef} value={policycancel?.cremark || ''}   name="cremark" required="true" autoComplete='off' placeholder="Enter the remarks" {...register("cremark", { required: true, mixLength: 3 })}  onChange={handleOnChange4}/>
  </Form.Group>

  </Row>
</>)}
<hr />

<div class="d-grid  col-2 mx-auto">
<Button variant="primary" type="submit" className='align-middle' >
<FontAwesomeIcon icon={faRightToBracket} /> Update
</Button>
</div>
{/* {piscLoading && (<Spinner variant='info' animation='border' />)} */}

</Form>
      </Tab>
      
      
      <Tab eventKey="occupancy-rule" title="Occupancy Rule" style={
               ruleoccupancy?.id == ''
                  ? mystyle3
                  : mystyle4
              }>
    


      <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit4(e))}> {/* handleOnSubmit() */}
      <input type="hidden" name="productid" id="productid" value={productId}/>
      <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridIsdummy">
  
  {/* <Form.Check type="checkbox" ref={ProductRef}  name="ageview"  label="Age Policy"  onChange={handleageview} /> */}
 
</Form.Group> 
</Row>
    <><Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Minimum Adult <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="1" max="500" ref={ProductRef}  name="minadult" required="true" value={ruleoccupancy?.minadult || ''} disabled={pxData.adult_permission? !pxData.adult_permission : !prmdata?.aap} autoComplete='off' placeholder="Enter Minimum Adult" {...register("minadult", { required: true, mixLength: 3 })}  onChange={handleOnChange5}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(1, Math.min(500, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
  </Form.Group>
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Maximum Adult <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min={ruleoccupancy?.minadult } max="500" ref={ProductRef}  name="maxadult" required="true" value={ruleoccupancy?.maxadult || ''} disabled={pxData.adult_permission? !pxData.adult_permission : !prmdata?.aap} autoComplete='off' placeholder="Enter Maximum Adult" {...register("maxadult", { required: true, mixLength: 3 })}  onChange={handleOnChange5}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(ruleoccupancy?.minadult, Math.min(500, inputValue));
        event.target.value = inputValue;
      }
    }}
    />
  </Form.Group>
 
 
  </Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Minimum Child <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" ref={ProductRef} min="1" max="500"  name="minchild" value={ruleoccupancy?.minchild || ''} disabled={pxData.child_permission? !pxData.child_permission : !prmdata?.acp} required="true" autoComplete='off' placeholder="Enter Minimum Child" {...register("minchild", { required: true, mixLength: 3 })}  onChange={handleOnChange5}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(1, Math.min(500, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
  </Form.Group>

  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Maximum Child <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min={ruleoccupancy?.minchild} max="500" ref={ProductRef}  name="maxchild" value={ruleoccupancy?.maxchild || ''} disabled={pxData.child_permission? !pxData.child_permission : !prmdata?.acp}required="true" autoComplete='off' placeholder="Enter Maximum Child" {...register("maxchild", { required: true, mixLength: 3 })}  onChange={handleOnChange5}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(ruleoccupancy?.minchild, Math.min(500, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
  </Form.Group>
 
 
  </Row>


  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Minimum Infant <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="1" max="500" ref={ProductRef}  name="mininfant" value={ruleoccupancy?.mininfant || ''} disabled={pxData.infant_permission? !pxData.infant_permission : !prmdata?.aip} required="true" autoComplete='off' placeholder="Enter Minimum Infant" {...register("mininfant", { required: true, mixLength: 3 })}  onChange={handleOnChange5}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(1, Math.min(500, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
  </Form.Group>

  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Maximum Infant <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min={ruleoccupancy?.mininfant} max="500" ref={ProductRef}  name="maxinfant" value={ruleoccupancy?.maxinfant || ''} disabled={pxData.infant_permission? !pxData.infant_permission : !prmdata?.aip} required="true" autoComplete='off' placeholder="Enter Maximum Infant" {...register("maxinfant", { required: true, mixLength: 3 })}  onChange={handleOnChange5}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(ruleoccupancy?.mininfant, Math.min(500, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
  </Form.Group>
 
  </Row>
</>



<div class="d-grid  col-2 mx-auto">
<Button variant="primary" type="submit" className='align-middle' >
<FontAwesomeIcon icon={faRightToBracket} /> Update
</Button>
</div>
{/* {piscLoading && (<Spinner variant='info' animation='border' />)} */}

</Form>
      </Tab>
      
      
    </Tabs>
          
    </div>
    </div>
    </div>
    </>
  );
}

export default ModifyProduct;